import { FC, useCallback, useEffect } from "react";
import { ViewProps } from "../types";
import { useRouter } from "next/router";

export const withScrollTo = (View: FC<ViewProps>) => (props: ViewProps) => {
  const router = useRouter();

  useEffect(() => {
    if (window?.location?.hash && !props?.pageLoading) {
      const value = window?.location?.hash?.split("#");
      const hashValue = value?.[value?.length - 1];

      const element = document.getElementById(hashValue);
      element?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }, [props?.pageLoading]);

  const scrollIntoView = useCallback(() => {
    const hash = router?.asPath.split("#")[1];
    const element = document.getElementById(hash);

    !props?.pageLoading &&
      element?.scrollIntoView({
        behavior: "smooth",
      });
  }, [props?.pageLoading, router?.asPath]);

  useEffect(() => {
    !props?.pageLoading && setTimeout(scrollIntoView, 1500);
  }, [props?.pageLoading, scrollIntoView]);

  return <View {...props} />;
};
